import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ChevronRight, FileText, Scale } from 'lucide-react';
import { apiFetch } from '../utils/api';
import { useTranslation } from 'react-i18next';

const DietsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [diets, setDiets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch('/api/diets')
      .then((r) => r.ok ? r.json() : [])
      .then(setDiets)
      .catch(() => setDiets([]))
      .finally(() => setLoading(false));
  }, []);

  const formatDate = (iso) => {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
  };

  if (loading) return <div className="loading"><div className="loading-spinner" /></div>;

  return (
    <div className="page-container animate-fade-in">
      <div className="header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <button
            className="btn btn-icon btn-secondary"
            onClick={() => navigate(-1)}
            style={{ flexShrink: 0 }}
          >
            <ArrowLeft size={20} />
          </button>
          <div>
            <p className="text-muted" style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>DragonFit</p>
            <h1 className="header-title">{t('diets.page_title')}</h1>
          </div>
        </div>
        <img src="/dragon-logo.png" alt="DragonFit" className="header-logo" />
      </div>

      {diets.length === 0 ? (
        <div className="empty-state">
          <Scale className="empty-icon" />
          <h3 className="empty-title">{t('diets.empty_title')}</h3>
          <p className="empty-desc">{t('diets.empty_desc')}</p>
        </div>
      ) : (
        diets.map((diet) => {
          const isUnread = !diet.read_by_athlete;
          return (
            <div
              key={diet.diet_id}
              className="card mb-3"
              style={{
                cursor: 'pointer',
                position: 'relative',
                borderColor: isUnread ? 'rgba(var(--primary-rgb),0.5)' : undefined,
              }}
              onClick={() => navigate(`/diets/${diet.diet_id}`)}
            >
              {isUnread && (
                <span style={{
                  position: 'absolute', top: '14px', right: '14px',
                  width: '10px', height: '10px', borderRadius: '50%',
                  background: 'var(--primary)', boxShadow: '0 0 8px rgba(var(--primary-rgb),0.7)',
                }} />
              )}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1, minWidth: 0 }}>
                  <div style={{
                    width: '42px', height: '42px', borderRadius: '12px',
                    background: 'rgba(var(--primary-rgb),0.15)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    flexShrink: 0,
                  }}>
                    <FileText size={20} style={{ color: 'var(--primary)' }} />
                  </div>
                  <div style={{ minWidth: 0 }}>
                    <p style={{ fontWeight: '600', color: 'var(--foreground)', marginBottom: '2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {diet.title}
                    </p>
                    <p style={{ fontSize: '13px', color: 'var(--muted-foreground)' }}>
                      {formatDate(diet.created_at)}
                    </p>
                  </div>
                </div>
                <ChevronRight size={18} style={{ color: 'var(--muted-foreground)', flexShrink: 0, marginLeft: '8px' }} />
              </div>
              {diet.notes && (
                <p style={{
                  fontSize: '13px', color: 'var(--muted-foreground)',
                  marginTop: '10px', paddingTop: '10px',
                  borderTop: '1px solid var(--border)',
                  overflow: 'hidden', display: '-webkit-box',
                  WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                }}>
                  {diet.notes}
                </p>
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

export default DietsPage;
